export default "__VITE_ASSET__CKwUjvqG__"